import type { AccordionDetailsProps, AccordionProps, AccordionSummaryProps } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

import { ArrowDownIcon } from '../icons';

const StyledAccordion = styled(Accordion)(() => ({
  borderRadius: '0.75rem',
  '&:before': {
    background: 'transparent',
  },
  '&:first-of-type': {
    borderRadius: '0.75rem',
  },
  '&:last-of-type': {
    borderRadius: '0.75rem',
  },
}));

export const AccordionContainer = (props: AccordionProps) => {
  const { className = 'mb-1 rounded-xl border border-solid border-divider shadow-none', ...rest } = props;
  return (
    <StyledAccordion
      disableGutters
      square={false}
      {...rest}
      TransitionProps={{ unmountOnExit: true }}
      className={className}
    />
  );
};

export const AccordionSummaryContainer = (props: AccordionSummaryProps) => {
  const { expandIcon = <ArrowDownIcon />, ...rest } = props;
  return <AccordionSummary {...rest} expandIcon={expandIcon} />;
};

export const AccordionDetailsContainer = (props: AccordionDetailsProps) => {
  return <AccordionDetails {...props} className="pb-1 pt-0" />;
};
